module.exports = __webpack_public_path__ + "static/media/blue_circle.522e77e0.svg";